/**
 * @desc assets静态资源动态导入
 * @param {string} fileName - 图像名称（例如：banner.png 传入值为：banner.png）
 * @returns 目标图像文件路径
 */
export function getAssetsPath(fileName: string) {
    return require(`../assets/img/${fileName}`)
}